import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";
import { HyperwalletUser } from "../types/HyperwalletUser";

export enum TypeKeys {
    FETCH_BEGIN = "PAYMENT_ACCOUNT/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "PAYMENT_ACCOUNT/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "PAYMENT_ACCOUNT/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "PAYMENT_ACCOUNT/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "PAYMENT_ACCOUNT/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "PAYMENT_ACCOUNT/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<HyperwalletUser, {}, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
